import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Life.scss";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from "../../ContextData/ContextData"; // assuming birth details come from context
import Footer from "../../../../../components/Footer/Footer";

const Life = () => {
  const { userData } = useFormData(); // e.g., { year, month, day, hour, minute }
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userData) return;

    const fetchPrediction = async () => {
      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/predict-life`,
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
            },
          }
        );
        setPrediction(response.data);
      } catch (err) {
        setError("Failed to load predictions.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrediction();
  }, [userData]);

  if (loading) {
    return (
      <div className="prediction-container">
        <InnerNav />
        <p>Loading predictions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="prediction-container">
        <InnerNav />
        <p className="error">{error}</p>
      </div>
    );
  }

  return (
    <div className="prediction-container">
      <InnerNav />
      <h2>{prediction?.aspect}</h2>

      {prediction?.sections &&
        Object.entries(prediction.sections).map(([title, content]) => (
          <div className="prediction-card" key={title}>
            <h3>{title}</h3>
            <p>{content}</p>
          </div>
        ))}
        <Footer/>
    </div>
  );
};

export default Life;
